<div class="relative flex flex-col w-full h-full">
    <!-- Dismiss button -->
    @if (data.dismissible) {
        <ng-container>
            <div class="mat-card-header flex flex-row justify-between items-center p-2 dark:bg-black dark:bg-opacity-10">
                <h3 class="mat-card-header-title uppercase m-1 font-extrabold dark:text-white">
                    {{ data.header }}
                </h3>
                <button mat-icon-button [matDialogClose]="false">
                    <mat-icon
                        class="text-secondary dark:text-white"
                        [svgIcon]="'feather:x'"
                    ></mat-icon>
                </button>
            </div>
            <hr class="m-0" />
        </ng-container>
    }

    <!-- Content -->
    <div class="flex flex-col items-center p-5">
        <!-- Icon -->
        @if (data.icon.show) {
            <ng-container>
                <div
                    class="flex flex-0 items-center justify-center w-30 h-30 sm:mr-4 rounded-full"
                    [ngClass]="{
                        'text-primary-600 bg-primary-100 dark:text-primary-50 dark:bg-primary-600':
                            data.icon.color === 'primary',
                        'text-accent-600 bg-accent-100 dark:text-accent-50 dark:bg-accent-600':
                            data.icon.color === 'accent',
                        'text-warn-600 bg-warn-100 dark:text-warn-50 dark:bg-warn-600':
                            data.icon.color === 'warn',
                        'text-gray-600 bg-gray-100 dark:text-gray-50 dark:bg-gray-600':
                            data.icon.color === 'basic',
                        'text-blue-600 bg-blue-100 dark:text-blue-50 dark:bg-blue-600':
                            data.icon.color === 'info',
                        'text-green-500 bg-green-100 dark:text-green-50 dark:bg-green-500':
                            data.icon.color === 'success',
                        'text-amber-500 bg-amber-100 dark:text-amber-50 dark:bg-amber-500':
                            data.icon.color === 'warning',
                        'text-red-600 bg-red-100 dark:text-red-50 dark:bg-red-600':
                            data.icon.color === 'error'
                    }"
                >
                    <mat-icon
                        class="text-current icon-size-20"
                        [svgIcon]="'heroicons_outline:' + data.icon.name"
                    ></mat-icon>
                </div>
            </ng-container>
        }

        @if (data.title || data.message) {
            <ng-container>
                <div class="flex flex-col items-center mt-4 space-y-1 text-center">
                   
                     <!-- Title -->
                    @if (data.title) {
                        <ng-container>
                            <div
                                class="text-xl leading-6 font-bold"
                                [innerHTML]="data.title"
                            ></div>
                        </ng-container>
                    }

                     <!-- Message -->
                    @if (data.message) {
                        <ng-container>
                            <div
                                class="text-secondary leading-6"
                                [innerHTML]="data.message"
                            ></div>
                        </ng-container>
                    }
                    
                </div>
            </ng-container>
        }

        <!-- Input -->
         @if (data.widthInput) {
             <ng-container>
                 <div class="flex flex-row mt-4 w-11/12">
     
                     <mat-form-field
                     class="w-full"
                     appearance="outline"
                     >
                         <mat-label>Motivo</mat-label>
                         <textarea
                             matInput
                             placeholder="Motivo Anulacion"
                             [formControl]="txtMotivo"
                             cdkTextareaAutosize
                             cdkAutosizeMinRows="4"
                             cdkAutosizeMaxRows="4"
                         ></textarea>
                     </mat-form-field>
     
                 </div>
             </ng-container>
         }
    </div>

    <!-- Actions -->
    @if (data.actions.confirm.show || data.actions.cancel.show) {
        <ng-container>
            <div
                class="flex flex-row items-center justify-evenly px-6 py-4 space-x-3 dark:bg-black dark:bg-opacity-10"
            >

                <!-- Cancel -->
                @if (data.actions.cancel.show) {
                    <ng-container>
                        <button
                            mat-flat-button
                            [color]="'warn'"
                            [matDialogClose]="false"
                        >
                            <mat-icon
                                class="text-secondary icon-size-4.5 dark:text-white"
                                [svgIcon]="'feather:thumbs-down'"
                            ></mat-icon>    
                            <span class="ml-1">
                                {{ data.actions.cancel.label }}
                            </span>
                        </button>
                    </ng-container>
                }

                <!-- Confirm -->
                @if (data.actions.confirm.show) {
                    <ng-container>
                        <button
                            mat-flat-button
                            [color]="data.actions.confirm.color"
                            [matDialogClose]="true"
                        >
                            <mat-icon
                                class="text-secondary icon-size-4.5 dark:text-white"
                                [svgIcon]="'feather:thumbs-up'"
                            ></mat-icon> 
                            <span class="ml-1">{{ data.actions.confirm.label }}</span>
                        </button>
                    </ng-container>
                }
            </div>
        </ng-container>
    }
</div>

